import { DocsBlockPropertyDefinition, } from "./SDKDocsBlockProperty";
/** Image property - Definition */
export class DocsBlockImagePropertyDefinition extends DocsBlockPropertyDefinition {
}
